import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import UserFormModal from '../Form/View'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import { ClientSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'
import Filter from './Components/Filter'

import useViewModel from './ViewModel'

const UserManagementView: React.FC = () => {
  const { searchText, setSearchText, data, TABLE_CONFIGS, handleOpenUserModal } = useViewModel()

  return (
    <ViewPageTitle>
      <UserFormModal />
      <Filter />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        {/* begin:: Table */}
        <div className='col-12'>
          <div className='card'>
            {/* begin:: Header */}
            <div className='card-header'>
              <div className='card-title w-75'>
                <div className='row align-items-center w-100'>
                  <div className='col-12 col-xl-4 mb-5 mb-xl-0'>
                    <div className='d-flex flex-row align-items-center'>
                      <label
                        className=' d-none d-xl-block me-4 fs-7 fw-bold'
                        style={{ whiteSpace: 'nowrap' }}>
                        คำค้นหา:{' '}
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        placeholder='ชื่อ, นามสกุล'
                        value={searchText}
                        onChange={(e: any) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className='col-12 col-xl-4 mb-5 mb-xl-0'>
                    <div className='d-flex flex-row align-items-center'>
                      <button className='btn btn-sm btn-primary fw-bold'>ค้นหา</button>
                    </div>
                  </div>
                </div>
              </div>
              {/* end:: Header */}

              <div className='card-toolbar'>
                <button
                  onClick={handleOpenUserModal}
                  className='btn btn-sm btn-light-success ms-4 fw-bold'
                  style={{ whiteSpace: 'nowrap' }}>
                  <KTSVG path='/media/icons/duotune/general/gen041.svg' svgClassName='svg-icon-1' />
                  เพิ่ม
                </button>
              </div>
            </div>
            {/* end:: Header */}

            {/* begin:: Body */}
            <div className='card-body'>
              <ClientSideTable isGrey data={data} columns={TABLE_CONFIGS} items_per_page={10} />
            </div>
            {/* end:: Body */}
          </div>
        </div>
        {/* end:: Table */}
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '/users',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/coding/cod001.svg',
          },
        ]}>
        จัดการผู้ใช้งาน
      </PageTitle>

      {children}
    </>
  )
}

export default UserManagementView
